// Recommended Listings Page - Matches screenshot exactly
import React, { useState, useEffect } from "react";
import { Typography } from "antd";
import TopFilterBar from "./components/TopFilterBar";
import BuySignalsListingCard from "./components/BuySignalsListingCard";
import { mockListings } from "./mockListingsData";
import "../../styles/dashboardCardTokens.css";
import styles from "./recommended.module.css";

const { Title } = Typography;

export default function RecommendedListings() {
  const [listings] = useState(mockListings);
  const [selectedListing, setSelectedListing] = useState(mockListings[0]);
  const [filters, setFilters] = useState({
    make: "Toyota",
    model: "Camry",
    yearRange: "2019-2022",
    location: "Fremont, CA +75 mi",
    priceRange: "$8k-$22k",
    domPeriod: "30D"
  });

  // Enable scrolling and scroll to top on mount
  useEffect(() => {
    const contentEl = document.querySelector('.content-ant.main-content');
    if (contentEl) {
      // Enable scrolling for this page
      contentEl.style.setProperty('overflow-y', 'auto', 'important');
      contentEl.style.setProperty('overflow-x', 'hidden', 'important');
      contentEl.style.setProperty('height', 'calc(100vh - 40px)', 'important');
      
      // Scroll to top
      contentEl.scrollTo({ top: 0, behavior: 'instant' });
      window.scrollTo({ top: 0, behavior: 'instant' });
      
      return () => {
        // Cleanup - restore defaults
        contentEl.style.removeProperty('overflow-y');
        contentEl.style.removeProperty('overflow-x');
        contentEl.style.removeProperty('height');
      };
    }
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters });
  };

  const handleListingClick = (listing) => {
    setSelectedListing(listing);
  };

  return (
    <div className={`${styles.pageContainer} recommended-listings-page`} style={{ padding: '0 24px 12px', paddingLeft: '4px', position: 'relative', paddingTop: '24px', marginTop: '-60px', overflow: 'hidden' }}>
      {/* Header Section */}
      <div className={styles.headerSection}>
        <div className={styles.headerTop}>
          <div className={styles.headerLeft}>
            <Title 
              level={1} 
              style={{ 
                color: '#ffffff', 
                marginBottom: 0,
                fontWeight: 700,
                fontSize: '20px',
                marginTop: 0,
                marginLeft: '0',
                paddingTop: 0,
                lineHeight: 1.3,
                overflow: 'visible'
              }}
            >
              Buy Signals
            </Title>
            <span className={styles.matchesBadge}>
              {listings.length} Matches
            </span>
          </div>
          <a href="#stack-rank" className={styles.stackRankLink}>
            Stack Rank <span className={styles.chevron}>›</span>
          </a>
        </div>
        
        {/* Trim Mix Pills */}
        <div className={styles.trimMixSection}>
          <span className={styles.trimMixLabel}>Nearby Trim Mix:</span>
          <div className={styles.trimMixPills}>
            <span className={styles.trimPill}>50% SE</span>
            <span className={styles.trimPill}>35% LE</span>
            <span className={styles.trimPill}>10% XLE</span>
            <span className={styles.trimPill}>5% other</span>
          </div>
        </div>
      </div>

      {/* Top Filter Bar */}
      <TopFilterBar filters={filters} onFilterChange={handleFilterChange} />

      {/* Main Content - Single Column */}
      <div className={styles.mainContent}>
        <div className={styles.listingsColumn}>
          <section className="rlCard" aria-label="Buy Signals Listings">
            <div className="rlList">
              {listings.map((listing) => (
                <BuySignalsListingCard
                  key={listing.id}
                  listing={listing}
                  isSelected={selectedListing.id === listing.id}
                  onClick={() => handleListingClick(listing)}
                />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
